import { EntityFieldFragment } from 'types/graphql'

import { ColumnData } from 'src/components/shared/FieldValueTable'
import {
  buildOtherLayerFieldRowsForIntersectingEntities,
  IntersectingOtherEntityForPropertyTab,
} from 'src/pages/RecordPage/Record/tabs/PropertyTab/propertyTabOtherLayerFields'
import { filterNil } from 'src/utils'

export type GraphqlIntersectingOtherEntityForEvPickerTooltip = {
  id: number
  uuid?: string | null
  name: string
  layer?: {
    id?: number | null
    uuid?: string | null
    name?: string | null
  } | null
  latestVersion?: {
    id?: number | null
    fields?: EntityFieldFragment[] | null
  } | null
}

/** Maps GraphQL intersecting Other entities into the Property Tab shape for tooltip display. */
export const mapIntersectingOtherEntitiesForEvPickerTooltip = (
  intersectingOtherEntities: GraphqlIntersectingOtherEntityForEvPickerTooltip[] | null | undefined
): IntersectingOtherEntityForPropertyTab[] =>
  filterNil(
    (intersectingOtherEntities ?? []).map((entity) => {
      if (!entity.uuid || !entity.layer?.id || !entity.layer.uuid || !entity.layer.name) {
        return null
      }

      return {
        id: entity.id,
        uuid: entity.uuid,
        name: entity.name,
        layer: {
          id: entity.layer.id,
          uuid: entity.layer.uuid,
          name: entity.layer.name,
        },
        latestVersion: entity.latestVersion,
      }
    })
  )

/**
 * Builds apply-form EV picker tooltip rows from address/parcel GIS fields plus
 * intersecting Other-layer entities (public-visible fields only, via GraphQL).
 */
export const buildApplyFormEvPickerTooltipRows = (
  addressParcelFields: EntityFieldFragment[],
  intersectingOtherEntities: IntersectingOtherEntityForPropertyTab[] = []
): ColumnData[] => {
  const addressParcelRows: ColumnData[] = addressParcelFields.map((field) => ({
    fieldName: field.entityFieldTemplate?.label || '',
    key: `${field.id}`,
    fieldValue: field.stringifiedValue || '',
  }))

  const otherLayerRows = buildOtherLayerFieldRowsForIntersectingEntities(intersectingOtherEntities)

  return [...addressParcelRows, ...otherLayerRows]
}
